import { AxiosInstance } from 'axios';

import * as types from '../../../../../../typings/api/skymap/rest/internal/project';

export class ProjectServiceInternal implements types.Handlers {
  constructor(private axios: AxiosInstance) {}

  async getValidToDate({
    path,
  }: types.GetValidToDateParameters): Promise<types.GetValidToDateResponse> {
    const { data } = await this.axios.get<types.GetValidToDateResponse>(
      `/project/${path.projectId}/valid-to-date`,
    );
    return data;
  }

  async getIntegrationGrants({
    path,
  }: types.GetIntegrationGrantsParameters): Promise<types.GetIntegrationGrantsResponse> {
    const { data } = await this.axios.get<types.GetIntegrationGrantsResponse>(
      `/project/${path.projectId}/integration-grants`,
    );
    return data;
  }

  async createIntegrationGrant({
    path,
    body,
  }: types.CreateIntegrationGrantParameters): Promise<types.CreateIntegrationGrantResponse> {
    const { data } = await this.axios.post<types.CreateIntegrationGrantResponse>(
      `/project/${path.projectId}/integration-grants`,
      body,
    );
    return data;
  }

  async revokeIntegrationGrant({ path }: types.RevokeIntegrationGrantParameters): Promise<void> {
    await this.axios.delete(`/project/${path.projectId}/integration-grants/${path.grantId}`);
  }
}
